import { createIcon } from '@chakra-ui/react';

export const MaestroIcon = createIcon({
  displayName: 'MaestroIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
        <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#E4E4E7" />
        <path
          d="M13.2715 5.22397C17.0399 5.22421 20.0947 8.31503 20.0947 12.1273C20.0945 15.9394 17.0398 19.0294 13.2715 19.0296C9.50293 19.0296 6.44744 15.9395 6.44727 12.1273C6.44727 8.31488 9.50282 5.22397 13.2715 5.22397Z"
          fill="#ED0006"
        />
        <path
          d="M22.124 5.22397C25.8925 5.22421 28.9473 8.31503 28.9473 12.1273C28.9471 15.9394 25.8924 19.0294 22.124 19.0296C18.3555 19.0296 15.3 15.9395 15.2998 12.1273C15.2998 8.31488 18.3554 5.22397 22.124 5.22397Z"
          fill="#0099DF"
        />
        <path
          d="M17.6973 6.87497C19.1639 8.14109 20.0947 10.0236 20.0947 12.1269C20.0947 14.23 19.1636 16.1118 17.6973 17.3779C16.2309 16.1118 15.2998 14.23 15.2998 12.1269C15.2998 10.0236 16.2307 8.14109 17.6973 6.87497Z"
          fill="#6C6BBD"
        />
      </svg>
    </>
  ),
});
